const configureDataDog = (appEnv) => {
    const datadogScript = document.createElement('script');
    datadogScript.id = 'DD_RUM';
    const head =
        document.head || document.getElementsByTagName('head')[0] || document.documentElement;
    datadogScript.src = 'https://www.datadoghq-browser-agent.com/us5/v5/datadog-rum-slim.js';
    datadogScript.async = true;
    datadogScript.rel = 'preconnect';
    document.head.appendChild(datadogScript);
    datadogScript.onload = () => {
        window.DD_RUM.onReady(() => {
            const domains = [];
            domains.push(env.API_URL);
            domains.push(env.InternalCDNBaseUrl);
            domains.push(env.ExternalCDNBaseUrl);
            window.DD_RUM.init({
                clientToken: env.DataDog.clientToken,
                applicationId: env.DataDog.applicationId,
                // see https://docs.datadoghq.com/getting_started/site/
                site: 'us5.datadoghq.com',
                service: 'apexwidgets',
                env: env.Environment,
                trackViewsManually: true,
                // Specify a version number to identify the deployed version of your application in Datadog
                // version: '1.0.0',
                useCrossSiteSessionCookie: true,
                // trackSessionAcrossSubdomains: true,
                sessionSampleRate: 100,
                sessionReplaySampleRate: 0,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: 'mask-user-input',
                beforeSend: (event, context) => {
                    if (event.type === 'error' && event.error && event.error.stack) {
                        // Ignore errors not originating from widget script
                        if (
                            event.error.stack.includes('webpack://apexchatwidgets/') ||
                            event.error.stack.includes('/contents/scripts/dist/')
                        ) {
                            return true;
                        }
                        return false;
                    }
                    if (
                        event.view.name === 'apexchat_bar_invitation' ||
                        event.view.name === 'apexchat_tab_invitation' ||
                        event.view.name === 'apexchat_dropdown_invitation' ||
                        event.view.name === 'apexchat_exitpopup2_chatwindow' ||
                        event.view.name === 'apexchat_dompopup_chatwindow' ||
                        event.view.name === 'apexchat_video_greet_invitation' ||
                        event.view.name === 'apexchat_prechat_invitation'
                    ) {
                        if (event.type === 'resource' && event.resource) {
                            return (
                                domains.some((domain) => event.resource.url.startsWith(domain)) ||
                                event.resource.url.includes('invitation.ashx?company')
                            );
                        }
                        // do not show telemetry from clients web pages
                        // console.log(`Blocked telemetry from ${event.view.url}`);
                        return true; // Discard telemetry not from your domain
                    }
                    return false;
                }
            });
        });
    };
};
export default configureDataDog;
